'use es6';

import { useState, useEffect } from 'react';
import * as fintechOutagesApiClient from '../utils/fintechOutagesApiClient.util';

const useFetchFintechOutagesStatus = (hubId, onError) => {
  const [data, setData] = useState({
    zuora: {
      isDown: false
    }
  });
  useEffect(() => {
    fintechOutagesApiClient.fetchZuoraOutageStatus(hubId).then(response => setData({
      zuora: {
        isDown: !!response.down,
        outageReason: response.reason,
        outageStartTime: response.startTime,
        outageEndTime: response.endTime
      }
    })).catch(onError);
  }, [data.isDown, hubId, onError]);
  return data;
};

export default useFetchFintechOutagesStatus;